// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"19be41e0","513":"730af781","703":"79786c28"}[chunkId] + ".chunk.js";
};